import { API_BASE_URL } from "./apiConfig";
import { logApiContext } from "../config/apiBaseUrl";

const BASE_PATH = `${API_BASE_URL}/api/turnos`;
const logRequest = (action, url, payload) =>
  logApiContext(`turnoCreationService:${action}`, { url, BASE_PATH, payload });

export const createTurno = async ({
  driverId,
  licenseId,
  startKm,
  endKm,
  startServices = 0,
  endServices = 0,
  startIncome,
  endIncome,
  csvText,
  csvName,
  creditIncome = 0,
  cardIncome = 0,
  gas = 0,
  date,
  services = [],
}) => {
  const servicesWithDriver = Array.isArray(services)
    ? services.map((svc) => ({
        ...svc,
        driver: svc.driver || svc.driverId || driverId || undefined,
      }))
    : [];
  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };
  const isBossFlow = Boolean(driverId);
  const url = isBossFlow ? `${BASE_PATH}/create/${driverId}` : `${BASE_PATH}/createAccountingClosure`;
  const payload = {
    license: licenseId,
    startKm,
    endKm,
    startServices: toNumber(startServices),
    endServices: toNumber(endServices),
    startIncome,
    endIncome,
    creditIncome: toNumber(creditIncome),
    cardIncome: toNumber(cardIncome),
    gas: toNumber(gas),
    date,
    csvText,
    csvName,
    services: servicesWithDriver,
  };

  logRequest("createTurno", url, payload);
  console.info("[WEB][CreateTurn] POST", url, payload);

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("Error creando turno", {
      status: response.status,
      statusText: response.statusText,
      body: text,
      url,
      payload,
    });
    throw new Error(text || "No se pudo crear el turno");
  }

  return response.json();
};
